import { ApiGetRequest, ApiPostRequest, ApiDeleteRequest } from '../../api';
import { showNotif } from '../notification';

export const state = {
  data: {
    title: 'User Akses',
    title_form: 'Form User Akses',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/adm/conf',
      },
      {
        text: 'User Akses',
        href: '/adm/conf/user-akses',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_user_akses',
    sortDesc: true,
    fields: [
      {
        key: 'name',
        label: 'Name',
        sortable: true,
      },
      {
        key: 'email',
        label: 'Email',
        sortable: true,
      },
      {
        key: 'company',
        label: 'Company',
        sortable: true,
      },
      {
        key: 'location',
        label: 'Location',
        sortable: true,
      },
      {
        key: 'role',
        label: 'Role',
        sortable: true,
      },
      {
        key: 'status_user',
        label: 'Status',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    detail: false,
    form: {
      operasional: [],
      logistic: [],
      finance: [],
      setting: [],
    },
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  changeUserAkses(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchUserAkses(context, params = null) {
    let result = await ApiGetRequest(`conf/user-akses`, params);
    return !result.error ? result.data.object : [];
  },

  async getListBankAccount({ commit, state }) {
    commit('changeUserAkses', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      id_user_akses: data.id_user_akses,
    };

    let result = await ApiGetRequest(`opr/bank-account`, params);
    commit('changeUserAkses', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getListUserAkses({ commit, state }) {
    commit('changeUserAkses', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`conf/user-akses`, params);
    commit('changeUserAkses', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getDetailUserAkses({ commit, state }, payload = null) {
    commit('changeUserAkses', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`conf/user-akses/${payload.id}`);
    if (result.data && result.data.object) {
      let modul = ['operasional', 'logistic', 'finance', 'setting'];
      let form = data.form;
      modul.map((itemM) => {
        let akses = data.form[itemM] || [];
        if (
          result.data.object &&
          result.data.object[itemM] &&
          result.data.object[itemM].length
        ) {
          akses.map((item, index) => {
            let check = result.data.object[itemM].filter(
              (itemC) => itemC.name === item.name
            );

            if (check && check.length) {
              akses[index] = check[0];
            }
          });
        }

        form[itemM] = akses;
      });

      commit('changeUserAkses', {
        loading: false,
        form: {
          ...form,
          id_admin: result.data.object.id_user,
          name: result.data.object.name,
        },
      });
    } else {
      commit('changeUserAkses', {
        loading: false,
      });
    }

    return result.error ? false : true;
  },

  async submitHakAkses({ commit, state, dispatch }) {
    commit('changeUserAkses', {
      loading: true,
    });

    let result = await ApiPostRequest(`conf/user-akses`, state.data.form);
    commit('changeUserAkses', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deleteUserAkses({ commit, dispatch }, payload = null) {
    commit('changeUserAkses', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`conf/user-akses/${payload.id}`);
    commit('changeUserAkses', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
